module.exports = __webpack_public_path__ + "img/markerNewAddress.955b2b31.svg";